import React from 'react';
import PropTypes from 'prop-types';

const Percent = ({ width, height, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8333 4.16675L4.16667 15.8334"
        stroke="#9000FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5833 16.6667C15.7339 16.6667 16.6667 15.7339 16.6667 14.5833C16.6667 13.4327 15.7339 12.5 14.5833 12.5C13.4327 12.5 12.5 13.4327 12.5 14.5833C12.5 15.7339 13.4327 16.6667 14.5833 16.6667Z"
        stroke="#9000FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41666 7.49992C6.56725 7.49992 7.49999 6.56718 7.49999 5.41659C7.49999 4.26599 6.56725 3.33325 5.41666 3.33325C4.26607 3.33325 3.33333 4.26599 3.33333 5.41659C3.33333 6.56718 4.26607 7.49992 5.41666 7.49992Z"
        stroke="#9000FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Percent.defaultProps = {
  width: 20,
  height: 20
};

Percent.propTypes = {
  width: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOf([PropTypes.string, PropTypes.number])
};

export default Percent;
